export default "__VITE_ASSET__B6o2N6jB__"